import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Dictionary } from "src/app/store/models/common_types";
import { LineItemDeltaAlertAPIResponse } from "./alerts.model";

@Injectable({
  providedIn: "root",
})
export class AlertsDataService {
  apiEP: string = window.apiUrl;

  constructor(private http: HttpClient) {}

  getAllEventTypes(
    type: string,
    itemObjectParam: string,
    showDefaultSelected?: boolean,
  ): Observable<any> {
    let url = `${this.apiEP}/app/alerts/get_all_event_types?itemContentType=${type}`;
    if (type === "watchlist") {
      url = `${url}&itemObjectId=${itemObjectParam}`;
    } else {
      url = `${url}&itemObjectName=${itemObjectParam}`;
    }
    if (showDefaultSelected) {
      url = `${url}&showDefaultSelected=${showDefaultSelected}`;
    }
    return this.http.get(url);
  }

  getBrokerList(
    ticker: string,
    entitlementTypeModel: boolean,
  ): Observable<any> {
    return this.http.get(
      `${this.apiEP}/app/alerts/get_entitled_brokers?ticker=${ticker}&entitlement_type_model=${entitlementTypeModel}`,
    );
  }

  getUserBrokerEntitlementMap(
    watchlistId: string,
    entitlementTypeModel: boolean,
  ): Observable<any> {
    return this.http.get(
      `${this.apiEP}/app/alerts/get_current_user_ticker_broker_entitlement_map/?watchlist_id=${watchlistId}&entitlement_type_model=${entitlementTypeModel}`,
    );
  }

  getUserAlertDetails(type: string, key: string): Observable<any> {
    let url = `${this.apiEP}/app/alerts/user_alerts/?type=${type}`;
    if (type === "watchlist") {
      url = `${url}&watchlist_id=${key}`;
    } else {
      url = `${url}&ticker=${key}`;
    }
    return this.http.get(url);
  }

  submitAlertsData(jsonData: Dictionary<any>): Observable<any> {
    return this.http.post(`${this.apiEP}/app/alerts/user_alerts/`, jsonData);
  }

  getLineItemDeltaAlert(
    ticker: string,
  ): Observable<LineItemDeltaAlertAPIResponse> {
    return this.http.get<LineItemDeltaAlertAPIResponse>(
      `${this.apiEP}/app/alerts/lim_delta_alert_settings/?ticker=${ticker}`,
    );
  }

  saveLidAlert(data, ticker): Observable<LineItemDeltaAlertAPIResponse> {
    return this.http.post<LineItemDeltaAlertAPIResponse>(
      `${this.apiEP}/app/alerts/lim_delta_alert_settings/?ticker=${ticker}`,
      data,
    );
  }
}
